import { List } from 'antd'
import React from 'react'
import GradingCard from './GradingCard'
import { getAnswerByRubric } from '../../../../../../../../../../utils/question.helper'

const RubricGradingCardList = ({ question, questionRubrics, answers }) => {
    return (
        <List
            dataSource={questionRubrics}
            renderItem={questionRubric => (
                <GradingCard
                    className='mb-8'
                    questionRubric={questionRubric}
                    answer={getAnswerByRubric(answers, questionRubric, question)}
                />
            )}
        />
    )
}

export default RubricGradingCardList

